import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export const contasBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Financeiro",
    url: "#!",
  },
  {
    label: "Contas",
    active: true,
  },
];

export const contaBreadcrumbItems = (
  id?: string,
  nome?: string
): PageBreadcrumbItem[] => [
  {
    label: "Financeiro",
    url: "#!",
  },
  {
    label: "Contas",
    url: "/financeiro/contas",
  },
  {
    label: nome || id?.toString() || "Nova",
    active: true,
  },
]; 